import React from "react";

const ConfigContext = React.createContext({});

export default ConfigContext;
